import { render, staticRenderFns } from "./text-row-documents.vue?vue&type=template&id=6bd82ed4&scoped=true&"
import script from "./text-row-documents.vue?vue&type=script&lang=js&"
export * from "./text-row-documents.vue?vue&type=script&lang=js&"
import style0 from "./text-row-documents.vue?vue&type=style&index=0&id=6bd82ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd82ed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd82ed4')) {
      api.createRecord('6bd82ed4', component.options)
    } else {
      api.reload('6bd82ed4', component.options)
    }
    module.hot.accept("./text-row-documents.vue?vue&type=template&id=6bd82ed4&scoped=true&", function () {
      api.rerender('6bd82ed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-documents.vue"
export default component.exports